<template>
  <div class="form_divider" />
</template>
<script>
export default {
  name: 'FormSectionDivider'
}
</script>
<style lang="scss" scoped>
.form_divider {
    display: block;
    height: 1px;
    width: 100%;
    border-bottom: solid 1px #d0d0d0;
    margin: 15px 0 30px;
}
</style>
